module.exports = __webpack_public_path__ + "static/media/list_alt_new.1e388083.svg";